"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var setup = {
  description: 'Add a Model Context Protocol (MCP) asset that provides the protocols and specifications for seamless integration between different AI systems and tools.',
  flows: [{
    fields: []
  }]
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map